import { render, staticRenderFns } from "./ServiceItemInputConfig.vue?vue&type=template&id=1abfd31a&scoped=true"
import script from "./ServiceItemInputConfig.vue?vue&type=script&lang=js"
export * from "./ServiceItemInputConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abfd31a",
  null
  
)

export default component.exports